import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import BottomNav from '../components/BottomNav';
import AddModal from '../components/AddModal';
import Avatar from '../components/Avatar';
import TodayView from '../components/TodayView';
import TasksView from '../components/TasksView';
import CalendarView from '../components/CalendarView';
import RemindersView from '../components/RemindersView';
import DocumentsView from '../components/DocumentsView';
import FamilyView from '../components/FamilyView';
import AnnouncementsView from '../components/AnnouncementsView';
import EmergencyContactsView from '../components/EmergencyContactsView';
import ExpensesView from '../components/ExpensesView';
import ProfileView from '../components/ProfileView';
import NotificationBell from '../components/NotificationBell';
import ThemeToggle from '../components/ThemeToggle';
import { Plus } from 'lucide-react';

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block fixed left-0 top-0 h-full w-64 bg-surface border-r border-border">
        <Sidebar />
      </div>

      {/* Desktop top-right notification bell + theme toggle */}
      <div className="hidden lg:flex fixed top-5 right-8 z-40 items-center gap-3">
        <ThemeToggle />
        <NotificationBell />
      </div>

      {/* Mobile Top Header - avatar + notifications */}
      <div className="lg:hidden sticky top-0 z-30 glass border-b border-border px-4 py-3 flex justify-between items-center">
        <h1 className="text-lg font-display font-bold text-foreground tracking-tight">
          Vida en Orden
        </h1>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <NotificationBell />
          <button
            data-testid="mobile-profile-btn"
            onClick={() => navigate('/dashboard/profile')}
            className="rounded-full"
          >
            <Avatar name={user?.name} picture={user?.picture} size="sm" testId="mobile-avatar" />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="lg:ml-64 pb-20 lg:pb-0">
        <div className="container mx-auto px-4 sm:px-8 py-8 sm:py-12 max-w-6xl">
          <Routes>
            <Route path="/" element={<TodayView />} />
            <Route path="/tasks" element={<TasksView />} />
            <Route path="/calendar" element={<CalendarView />} />
            <Route path="/reminders" element={<RemindersView />} />
            <Route path="/announcements" element={<AnnouncementsView />} />
            <Route path="/documents" element={<DocumentsView />} />
            <Route path="/expenses" element={<ExpensesView />} />
            <Route path="/emergency" element={<EmergencyContactsView />} />
            <Route path="/family" element={<FamilyView />} />
            <Route path="/profile" element={<ProfileView />} />
          </Routes>
        </div>
      </div>

      {/* Floating Action Button */}
      <button
        data-testid="fab-add-btn"
        onClick={() => setShowAddModal(true)}
        className="js-hide-when-expense-form fixed bottom-24 lg:bottom-8 right-8 w-16 h-16 bg-primary text-primary-foreground rounded-full shadow-2xl shadow-primary/30 hover:brightness-110 transition-transform hover:scale-105 flex items-center justify-center z-40"
      >
        <Plus className="w-7 h-7" strokeWidth={1.75} />
      </button>

      {/* Bottom Navigation - Mobile only */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 glass border-t border-border z-30">
        <BottomNav />
      </div>

      {/* Modals */}
      {showAddModal && <AddModal onClose={() => setShowAddModal(false)} />}
    </div>
  );
}
